let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lT9FT")).then(() => parcelRequire('cqCj3'));